// load more btn

document.addEventListener('click', async function(e) {

  const btn = e.target.closest('.load-more-btn');

  if (!btn) return;

  e.preventDefault();

  const nextUrl = btn.dataset.nextUrl;

  if (!nextUrl) return;

  const originalText = btn.textContent;

  btn.classList.add('loading');
  btn.textContent = btn.dataset.loadingText || originalText;

  try {

    const response = await fetch(nextUrl);
    const html = await response.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const newProducts = doc.querySelector('#CollectionAjaxContent .grid');
    const currentProducts = document.querySelector('#CollectionAjaxContent .grid');

    if (newProducts && currentProducts) {
      currentProducts.insertAdjacentHTML(
        'beforeend',
        newProducts.innerHTML
      );
    }

    const newButton = doc.querySelector('.load-more-btn');

    if (newButton) {

      btn.dataset.nextUrl = newButton.dataset.nextUrl;

      // Dynamic translated text
      btn.textContent = newButton.textContent.trim();

    } else {

      btn.parentElement.remove();

    }

  } catch(error) {

    console.error(error);

    // Restore translated text
    btn.textContent = originalText;

  }

});

// Custom FAQ accordions
document.addEventListener('DOMContentLoaded', function () {
  function setInitialFaqHeight(content) {
    content.style.height = content.classList.contains('active') ? 'auto' : '0px';
  }

  function initializeFaqContents(scope) {
    scope.querySelectorAll('.js-custom-faq-content').forEach(setInitialFaqHeight);
  }

  function closeFaq(trigger, content) {
    if (!content.classList.contains('active')) return;

    content.style.height = content.scrollHeight + 'px';
    content.offsetHeight;
    content.classList.remove('active');
    trigger.classList.remove('active');
    trigger.setAttribute('aria-expanded', 'false');

    requestAnimationFrame(function () {
      content.style.height = '0px';
    });
  }

  function openFaq(trigger, content) {
    content.classList.add('active');
    trigger.classList.add('active');
    trigger.setAttribute('aria-expanded', 'true');
    content.style.height = '0px';

    requestAnimationFrame(function () {
      content.style.height = content.scrollHeight + 'px';
    });
  }

  initializeFaqContents(document);

  document.addEventListener('shopify:section:load', function (e) {
    initializeFaqContents(e.target);
  });

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.js-custom-faq-trigger');
    if (!trigger) return;

    const faqSection = trigger.closest('.custom-faq');
    const item = trigger.closest('.custom-faq__item');
    const content = item && item.querySelector('.js-custom-faq-content');
    if (!faqSection || !content) return;

    e.preventDefault();
    const isOpen = content.classList.contains('active');

    faqSection.querySelectorAll('.custom-faq__item').forEach(function (faqItem) {
      const itemTrigger = faqItem.querySelector('.js-custom-faq-trigger');
      const itemContent = faqItem.querySelector('.js-custom-faq-content');
      if (itemTrigger && itemContent) closeFaq(itemTrigger, itemContent);
    });

    if (!isOpen) openFaq(trigger, content);
  });

  document.addEventListener('transitionend', function (e) {
    const content = e.target.closest('.js-custom-faq-content');
    if (e.propertyName === 'height' && content && content.classList.contains('active')) {
      content.style.height = 'auto';
    }
  });
});

//home page review read more 

// document.addEventListener('click', function (e) {
//   const btn = e.target.closest('[data-review-toggle]');
//   if (!btn) return;

//   const wrapper = btn.closest('[data-review-wrapper]');
//   const isExpanded = wrapper.classList.toggle('is-expanded');

//   btn.textContent = isExpanded
//     ? btn.dataset.lessText
//     : btn.dataset.moreText;
// });

// js update a class in the home page slider section
function applyTabColors(clickedTrigger) {
  const nav = clickedTrigger.closest('.product-systems__tabs');
  if (!nav) return;

  const allTriggers = nav.querySelectorAll('.collection-switcher__trigger');
  const triggerIndex = Array.from(allTriggers).indexOf(clickedTrigger);
  const colorClass = triggerIndex === 0 ? 'is-petrol' : 'is-purple';

  // 1) Triggers
  allTriggers.forEach((t, i) => {
    t.classList.remove('is-petrol', 'is-purple');
    if (i === triggerIndex) {
      t.classList.add(colorClass);
    }
  });

  // 2) Collection wrapper divs + grids
  const section = nav.closest('[id^="shopify-section-"]') || document;
  const allCollections = section.querySelectorAll('.collection-switcher__collection.product-systems__collection');

  allCollections.forEach((col) => {
    col.classList.remove('is-petrol', 'is-purple');
    const grid = col.querySelector('.grid.collection-switcher__collection-grid');
    if (grid) grid.classList.remove('is-petrol', 'is-purple');
  });

  const targetId = clickedTrigger.getAttribute('aria-controls');
  const targetCollection = document.getElementById(targetId);
  if (targetCollection) {
    targetCollection.classList.add(colorClass);
    const targetGrid = targetCollection.querySelector('.grid.collection-switcher__collection-grid');
    if (targetGrid) targetGrid.classList.add(colorClass);
  }
}

// Capture phase par listener — koi bijo click handler (existing tab-switch script)
// navigation/class-reset kare tya pela j aapnu logic run thay, e mate true (capture) apyu
document.addEventListener('click', function (e) {
  const trigger = e.target.closest('.collection-switcher__trigger');
  if (!trigger) return;

  e.preventDefault();
  applyTabColors(trigger);
}, true);

// Page load par already-active (first) tab mate init
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-systems__tabs').forEach((nav) => {
    const activeTrigger = nav.querySelector('.collection-switcher__trigger.is-active');
    if (activeTrigger) {
      applyTabColors(activeTrigger);
    }
  });
});